import { useEffect } from 'react'

// Bind:
//   Cmd/Ctrl+K  → openPalette
//   g h         → tab heute (chord)
//   g b         → tab board
//   g d         → tab daten
//   g m         → tab mehr
//   c           → openCoach
//   ?           → openPalette + prefill 'help'
//   esc         → handled per-component

export function useKeyboardShortcuts({ openPalette, onTab, openCoach }) {
  useEffect(() => {
    let chord = null
    let chordTimer = null

    function shouldIgnore(e) {
      const tag = e.target?.tagName
      if (e.metaKey || e.ctrlKey || e.altKey) return false
      if (tag === 'INPUT' || tag === 'TEXTAREA' || e.target?.isContentEditable) return true
      return false
    }

    function clearChord() {
      chord = null
      if (chordTimer) clearTimeout(chordTimer)
      chordTimer = null
    }

    function onKey(e) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        openPalette?.()
        return
      }
      if (shouldIgnore(e)) return

      if (chord === 'g') {
        clearChord()
        if (e.key === 'h') { e.preventDefault(); onTab?.('heute'); return }
        if (e.key === 'b') { e.preventDefault(); onTab?.('board'); return }
        if (e.key === 'd') { e.preventDefault(); onTab?.('daten'); return }
        if (e.key === 'm') { e.preventDefault(); onTab?.('mehr');  return }
        return
      }

      if (e.key === 'g') { chord = 'g'; chordTimer = setTimeout(clearChord, 1200); return }
      if (e.key === 'c' && openCoach) { e.preventDefault(); openCoach?.(); return }
      if (e.key === '?') { e.preventDefault(); openPalette?.(); return }
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [openPalette, onTab, openCoach])
}
